import { mergeStyleSets } from '@uifabric/merge-styles';
import * as theme from './../theme/colors';

const reviewClassNames = (): { [key: string]: string } => mergeStyleSets({
  title: {
    fontSize: 24
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  orderDetails: {
    maxWidth: '120ch',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    selectors: {
      '&>*': {
        width: '100%'
      }
    }
  },
  note: {
    selectors: {
      label: {
        marginRight: '2ch'
      }
    }
  },
  notes: {
    borderTop: `1px solid ${theme.paleGray}`,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: '4ch',
    selectors: {
      '&>div': {
        maxWidth: '66%',
        display: 'flex',
        justifyContent: 'space-between'
      }
    }
  },
  addresses: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '4ch',
    borderTop: `1px solid ${theme.paleGray}`
  },
  addressBlock: {
    padding: 4,
    selectors: {
      '&>label:first-child' : {
        fontWeight: 'bold'
      },
      '&>div:nth-child(2)' : {
        marginTop: '1ch'
      }
    }
  },
  orderItems: {
    width: '100%'
  },
  orderItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '4ch',
    borderTop: `1px solid ${theme.paleGray}`,
    alignItems: 'flex-start'
  },
  orderItemImage: {
    maxWidth: 480,
    selectors: {
      '@media(max-width: 600px)': {
        maxWidth: '45vw'
      }
    }
  },
  orderItemInfo: {
    flexGrow: 1,
    paddingLeft: '2ch',
    selectors: {
      '&>label:first-child': {
        fontWeight: 'bold'
      }
    }
  }
});

export default reviewClassNames;
